import React from 'react';
import LensMenu from '../components/LensMenu';
import Layout from '../../shared/components/Layout';

const LensIndex: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <LensMenu />
      </Layout>
    </React.Fragment>
  )
}

export default LensIndex;
